import { render, staticRenderFns } from "./profile-annotator-config.vue?vue&type=template&id=10f9e8ea"
import script from "./profile-annotator-config.vue?vue&type=script&lang=js"
export * from "./profile-annotator-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports